if (!customElements.get('responsive-video')) {
  customElements.define(
    'responsive-video',
    class ResponsiveVideo extends HTMLElement {
      constructor() {
        super();

        this.video = this.querySelector('video');
        this.sources = this.querySelectorAll('video source');
      }

      connectedCallback() {
        window.addEventListener(
          'resize',
          window.debounce(() => this.updateVideoSource(), 500),
        );
      }

      updateVideoSource() {
        if (!this.sources) {
          return;
        }

        const newSource = Array.from(this.sources).find((source) => {
          const mediaQuery = source.getAttribute('media');
          return !mediaQuery || window.matchMedia(mediaQuery).matches;
        });

        if (
          newSource &&
          newSource instanceof HTMLSourceElement &&
          this.video &&
          this.video instanceof HTMLVideoElement &&
          this.video.src !== newSource.src
        ) {
          this.video.src = newSource.src;
          this.video.load();
        }
      }
    },
  );
}
